import React from "react";
import { withRouter } from "react-router";

import Types from "EventLight/Common/Types/View";

const Layout = ({ params }) => <Types moduleId={params.moduleId} />;

export default withRouter(Layout);
